module.exports = __webpack_public_path__ + "static/07-share-5df69df8b4741d8817384cc87bcb2e38.png";